import {
  referenceNumber,
  type TaskReferenceResolver,
  type TaskReferenceRoute,
} from '@src/features/tasks';

/** The "verify client" task opens the client page. */
export const clientTaskReference: TaskReferenceResolver = (
  data,
): TaskReferenceRoute | null => {
  const clientId = referenceNumber(data.id);
  if (clientId === null) {
    return null;
  }
  return {
    to: '/clients/$clientId',
    params: { clientId: String(clientId) },
  };
};
